import React, { useState, useRef, useEffect } from "react";
import {
  Col,
  Row,
  Form,
  Drawer,
  Space,
  Button,
  Spin,
  message,
  Flex,
} from "antd";
import { CitiesInput, CitiesTextEditor } from "../";
import OuthPrint from "./outh_print";
import { ReadyToPrint } from "./ReadyToPrint";
import {
  EditOutlined,
  PrinterOutlined,
  SaveOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { consentForm } from "../../services/consentForm";

const ConsentForm = ({ visible, onClose, clientInfo }) => {
  const printRef = useRef(null);
  const [form] = Form.useForm();
  const [editedConsent, setEditedConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const serviceID = clientInfo?.service_id;
  const clientDetails = clientInfo?.appointment?.client_info;
  useEffect(() => {
    if (serviceID) {
      form.setFieldsValue({
        name: clientDetails?.name,
        age: clientDetails?.age,
        city: clientDetails?.residence,
        fatherName: clientDetails?.fatherName,
        mrn: clientDetails?.mrn,
      });
      getAllInstructions();
    }
  }, [serviceID]);

  const getAllInstructions = async () => {
    setLoading(true);
    const res = await consentForm.getConsentForm({
      serviceID,
      pageNo: 1,
      recordsPerPage: 1,
    });
    if (res) {
      const instruction = res?.[0]?.instruction;
      form.setFieldsValue({ consent: instruction });
      setEditedConsent(instruction);
    } else {
      message.error("Failed to load instructions");
    }
    setLoading(false);
  };

  return (
    <Drawer
      title="Consent Form"
      width={800}
      onClose={onClose}
      open={visible}
      destroyOnClose
      footer={
        <Flex gap={5} justify="space-between">
          <Flex gap={5}>
            <Button
              style={{ background: "#2F80ED" }}
              className="text-white border-0"
              icon={<PrinterOutlined />}
              onClick={() => {
                printRef.current?.(); // safely call print
              }}
            >
              Print
            </Button>
            {!editedConsent && <Button onClick={onClose}>Close</Button>}
          </Flex>
          {editedConsent ? (
            <Flex gap={5}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => alert("changed")}
              >
                Save
              </Button>
              <Button onClick={() => setEditedConsent(false)}>Cancel</Button>
            </Flex>
          ) : (
            <Button
              icon={<EditOutlined />}
              onClick={() => setEditedConsent(true)}
            >
              Edit Consent
            </Button>
          )}
        </Flex>
      }
    >
      <Form layout="vertical" form={form} requiredMark={false}>
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <CitiesInput
              name="mrn"
              label="MRN"
              required
              placeholder="MRN"
              disabled
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="name"
              label="Name"
              required
              placeholder="Your Name"
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="fatherName"
              label="Father Name"
              required
              placeholder="Father Name"
            />
          </Col>
          <Col span={12}>
            <CitiesInput name="age" label="Age" required placeholder="Age" />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="city"
              label="Address"
              required
              placeholder="City"
            />
          </Col>
          <Col span={24}>
            {loading ? (
              <Flex justify="center" align="center" style={{ height: "200px" }}>
                <Spin
                  size="large"
                  indicator={
                    <SyncOutlined
                      spin
                      style={{ color: "var(--main-color)", fontSize: "24px" }}
                    />
                  }
                />
              </Flex>
            ) : (
              <CitiesTextEditor
                disabled
                name="consent"
                label="Consent"
                required
                onChange={(val) => {
                  setEditedConsent(val); // ✅ change track karo
                  form.setFieldsValue({ consent: val });
                }}
              />
            )}
          </Col>
        </Row>
      </Form>

      {/* <Modal
        title="Consent Form"
        centered
        width="794px"
        open={visiblePrint}
        onCancel={() => setVisiblePrint(false)}
        footer={
          <Button
            type="primary"
            danger
            onClick={() => {
              printRef.current?.(); // safely call print
            }}
          >
            <PrinterOutlined /> Print
          </Button>
        }
        destroyOnClose // important to remount component each time
      >
        <ReadyToPrint
          print={printRef}
          name="Consent Form"
          Component={
            <OuthPrint
              data={form.getFieldsValue()}
              consentDelta={consentDelta}
            />
          }
        />
      </Modal> */}
      <div className="hidden">
        <ReadyToPrint
          print={printRef}
          name="Consent Form"
          Component={
            <div>
              <OuthPrint
                data={{
                  ...form.getFieldsValue(),
                  clientDetails,
                  consent: editedConsent,
                }}
              />
            </div>
          }
        />
      </div>
    </Drawer>
  );
};

export default ConsentForm;
